import React from "react";
import { BrowserRouter as Router, Routes, Route , Navigate } from "react-router-dom";

import Layout from "../components/Layout";
import MainHome from "../mainpages/MainHome"; // 新增首頁
import AboutMe from "../contact/AboutMe"; // 新增 AboutMe 頁面
import AboutDetail from "../contact/AboutDetail"; // 新增 AboutDetail 頁面
import Home from "../buddypages/Home";
import About from "../buddypages/About";
import Contact from "../buddypages/Contact";
import Roulette from "../buddypages/Roulette";
import Shop from "../buddypages/Shop";
import History from "../buddypages/History";
import AIrag from "../buddypages/AIrag";
import ErrorPage from "../buddypages/ErrorPage";
import ShopDetail from "../buddypages/shop/ShopDetail";
import Test from "../buddypages/Test";
import DiaryList from "../diary/DiaryList";
import DiaryEditor from "../diary/DiaryEditor";
import PrivateRoute from "../components/PrivateRoute";
import Login from "../pages/Login";
import DiaryDetail from '../diary/DiaryDetail';
import Team from "../pleasestepbacktoscan/team";


// const AppRoutes = () => {
//   return (
//     <Router>
//       <Routes>
//         {/* localhost 預設進入 MainHome */}
//         <Route path="/" element={<MainHome />} />
//         <Route path="/login" element={<Login />} />

//         {/* AboutMe 相關頁面 */}
//         <Route path="/about" element={<AboutMe />} />
//         <Route path="/about/detail/:section" element={<AboutDetail />} />

//         {/* 保護的日記路由 */}
//         <Route path="/diary" element={
//           <PrivateRoute>
//             <DiaryList />
//           </PrivateRoute>
//         } />
//         <Route path="/diary/new" element={
//           <PrivateRoute>
//             <DiaryEditor />
//           </PrivateRoute>
//         } />
//         <Route path="/diary/:id" element={<DiaryDetail />} />
//         <Route path="/diary/edit/:id" element={
//           <PrivateRoute>
//             <DiaryEditor />
//           </PrivateRoute>
//         } />

//         {/* Buddy 內的所有頁面 */}
//         <Route
//           path="/buddy/*"
//           element={
//             <Layout>
//               <Routes>
//                 <Route path="home" element={<Home />} />
//                 <Route path="about" element={<About />} />
//                 <Route path="contact" element={<Contact />} />
//                 <Route path="roulette" element={<Roulette />} />
//                 <Route path="shop" element={<Shop />} />
//                 <Route path="shop/:shopName" element={<ShopDetail />} />
//                 <Route path="history" element={<History />} />
//                 <Route path="airag" element={<AIrag />} />
//                 <Route path="test" element={<Test />} />
                
//                 {/* 通配符路由，處理未匹配的路徑 */}
//                 <Route path="*" element={<ErrorPage />} />
//               </Routes>
//             </Layout>
//           }
//         />
//       </Routes>
//     </Router>
//   );
// };
const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* 唯一有效頁面 */}
        <Route path="/pleasestepbacktoscan/team" element={<Team />} />

        {/* 所有其它路由一律跳轉 */}
        <Route path="*" element={<Navigate to="/pleasestepbacktoscan/team" replace />} />
      </Routes>
    </Router>
  );
};
export default AppRoutes;
